export function findBy (array, value, key) {
  for (let i = 0; i < array.length; i++) {
    if (key(array[i]) === value) {
      return i
    }
  }
  return null
}

export function getParameterByName (name, def) {
  def = typeof def !== 'undefined' ? def : null

  let regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  let res = regex.exec(window.location.search)

  if (res == null) {
    return def
  } else {
    return decodeURIComponent(res[1].replace(/\+/g, ' '))
  }
}

export function getLanguage () {
  let preferLang = window.navigator.userLanguage || window.navigator.language
  let lang = getParameterByName('language', preferLang.toLowerCase()).toLowerCase()
  if (lang.indexOf('-') > 0) {
    lang = lang.substr(0, lang.indexOf('-'))
  }

  let storeCountry = 'us'
  switch (lang) {
    case 'ko':
    case 'ko-kr':
      storeCountry = 'kr'
      break
    default:
      storeCountry = 'us'
      break
  }
  return storeCountry
}

export function getDefaultLanguage () {
  let languageCode = getLanguage()
  if (languageCode === 'kr' || languageCode === 'ko-kr' || languageCode === 'ko') {
    return 'ko'
  } else {
    return 'en'
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js